import { Component, Input, OnInit } from '@angular/core';
import { FacilitiesService, Facility } from '../../core/facilities/facilities.service';
import { AbstractBaseComponent } from '../abstract-base.component';
import * as AppConfig from '../../app.config';
import { MedAlertService } from "../../api/api/medAlert.service";
import { ClarificationsService } from "../../api/api/clarifications.service";
import { OwedMedicationService } from "../../api/api/owedMedication.service";
import { DocumentsPendingService } from "../../api/api/documentsPending.service";
import { UserService } from '../../core/user/user.service';
import { takeUntil, catchError } from 'rxjs/operators';
import { ApiRequestDto } from '../../api';


/**
 * U/I component to show side bar of various notification counts and provides a link to navigate to each of those screens.
 */
@Component({
    selector: 'my-home-sidebar',
    templateUrl: 'home-sidebar.component.html'
})
export class HomeSidebarComponent extends AbstractBaseComponent implements OnInit {

    readonly isDev = AppConfig.isDev;

    showPriorAuth: boolean = false;
    isBOOnly: boolean = false; //Only business office role - no others
    
    @Input()
    selectedSection: SelectedHomeSection;

    private _owedCount: number = 0;
    private _medAlertsCount: number = 0;
    private _complianceCount: number = 0;
    private _clarificationCount: number = 0;
    private _priorAuthCount: number = 0;
    isNurse: boolean = false;
    isCorporate: boolean = false;
    isDON: boolean = false;
    isBusinessOffice: boolean = false;

    @Input()
    private currentViewCount;

    get owedCount() : number  {
        return this.selectedSection == 'owed' ? this.currentViewCount :  this._owedCount
    }

    get medAlertsCount() : number  {
        return this.selectedSection == 'alerts' ? this.currentViewCount :  this._medAlertsCount;
    }

    get complianceCount() : number  {
        return this.selectedSection == 'formulary' ? this.currentViewCount  : this._complianceCount;
    }

    get clarificationCount() : number  {
        return this.selectedSection == 'clarifications'? this.currentViewCount : this._clarificationCount;
    }

    get priorAuthCount() : number  {
        return this.selectedSection == 'priorAuth'? this.currentViewCount : this._priorAuthCount;
    }

    constructor(private facilityService: FacilitiesService, private medAlertService: MedAlertService, private documentsPendingService: DocumentsPendingService,
                private clarificationService: ClarificationsService, private owedMedicationService: OwedMedicationService, private userSvc: UserService){
        super();
    }

    ngOnInit(){

        this.isCorporate = this.userSvc.isCorporate;
        this.isDON = this.userSvc.isDON;
        this.isBusinessOffice = this.userSvc.isBusinessOffice;
        this.isNurse = this.userSvc.isNurse;

        if(this.isCorporate || this.isDON || this.isBusinessOffice){
            this.showPriorAuth = true;
        }

        if(this.isBusinessOffice && !this.isCorporate && !this.isDON && !this.isNurse) {
            this.isBOOnly = true;
        }

        this.facilityService.selectedFacilities$.pipe(takeUntil(this.destroy$)).subscribe((facilities: Facility[]) =>
            {
                if(facilities.length) {
                    this.updateCounts();
                }
            }
        );
    }


    private updateCounts() {
        //for the current screen, do not make an API call and just use current number of items in the table
        if (this.selectedSection != 'alerts') { this.getMedAlertCount(); }
        if (this.selectedSection != 'formulary') { this.getComplianceCount(); }
        if (this.selectedSection != 'clarifications') { this.getClarificationsCount(); }
        if (this.selectedSection != 'owed') { this.getOwedMedsCount(); }
        if (this.selectedSection != 'priorAuth') { this.getPriorAuthCount(); }
    }

    private getClarificationsCount(){
        const requestParams: ApiRequestDto = { OrgList: this.facilityService.selectedAsOrgList };
        this.clarificationService.clarificationsGetClarificationsCount(requestParams)
            .pipe(takeUntil(this.stop$))
            .subscribe((data: number) => {
                if(typeof data === 'number'){
                    this._clarificationCount = data;
                }else{
                    this._clarificationCount = 0;
                }
            });
    }

    private getComplianceCount(){

    }

    private getOwedMedsCount() {
        const requestParams: ApiRequestDto = {
            OrgList: this.facilityService.selectedAsOrgList
        };
        this.owedMedicationService.owedMedicationGetOwedMedicationsCount(requestParams)
            .pipe(takeUntil(this.stop$))
            .subscribe((data: number) => {
                if (typeof data === 'number') {
                    this._owedCount = data;
                }
                else {
                    this._owedCount = 0;
                }
            });
    }

    private getMedAlertCount(){
        const requestParams: ApiRequestDto = { 
            OrgList: this.facilityService.selectedAsOrgList,
        };
        this.medAlertService.medAlertGetActiveAlertCount(requestParams)
            .pipe(takeUntil(this.stop$))
            .subscribe((data: number) => {
                if(typeof data === 'number'){
                    this._medAlertsCount = data;
                }else{
                    this._medAlertsCount = 0;
                }
            });
    }

    private getPriorAuthCount() {
        const requestParams: ApiRequestDto = {
            OrgList: this.facilityService.selectedAsOrgList
        };
        this.documentsPendingService.documentsPendingGetDocumentsPendingCount(requestParams)
            .pipe(takeUntil(this.stop$))
            .subscribe((data: number) => {
                console.log(this.facilityService.selectedAsOrgList)
                if (typeof data === 'number') {
                    this._priorAuthCount = data;
                } else {
                    this._priorAuthCount = 0;
                }
            });
    }


}

export type SelectedHomeSection = 'alerts'|'clarifications'|'owed'|'formulary'|'priorAuth';